'use client';

import { ChevronLeft, Shield } from 'lucide-react';
import { useTranslations, useLocale } from 'next-intl';
import { useRouter } from 'next/navigation';

export default function PrivacyClient() {
  const t = useTranslations();
  const locale = useLocale();
  const router = useRouter();
  const isRTL = locale === 'ar';

  return (
    <div
      className="w-full max-w-3xl mx-auto px-4 py-8 animate-in fade-in slide-in-from-bottom-4 duration-500"
      data-testid="privacy-policy"
    >
      <div className="flex items-center gap-4 mb-8">
        <button
          onClick={() => router.back()}
          className="p-2 rounded-full hover:bg-secondary transition-colors cursor-pointer"
          data-testid="privacy-back"
          aria-label={t('btn_back')}
        >
          <ChevronLeft className={`w-6 h-6 ${isRTL ? 'rotate-180' : ''}`} />
        </button>
        <div className="flex items-center gap-2">
          <Shield className="w-6 h-6 text-primary" />
          <h1 className="text-2xl font-bold">{t('privacy_title')}</h1>
        </div>
      </div>

      <div className="bg-card border border-border rounded-2xl p-6 md:p-8 shadow-sm space-y-6">
        <p className="text-muted-foreground text-sm">
          {t('privacy_last_updated')}: {t('privacy_date')}
        </p>

        <section className="space-y-3">
          <h2 className="text-lg font-semibold text-foreground">{t('privacy_intro_title')}</h2>
          <p className="text-foreground/80 leading-relaxed">{t('privacy_intro_text')}</p>
        </section>

        <section className="space-y-3">
          <h2 className="text-lg font-semibold text-foreground">{t('privacy_data_title')}</h2>
          <p className="text-foreground/80 leading-relaxed">{t('privacy_data_text')}</p>
          <ul className="list-disc list-inside text-foreground/80 space-y-1 ml-2">
            <li>{t('privacy_data_item1')}</li>
            <li>{t('privacy_data_item2')}</li>
            <li>{t('privacy_data_item3')}</li>
          </ul>
        </section>

        <section className="space-y-3">
          <h2 className="text-lg font-semibold text-foreground">{t('privacy_cookies_title')}</h2>
          <p className="text-foreground/80 leading-relaxed">{t('privacy_cookies_text')}</p>
        </section>

        <section className="space-y-3">
          <h2 className="text-lg font-semibold text-foreground">{t('privacy_analytics_title')}</h2>
          <p className="text-foreground/80 leading-relaxed">{t('privacy_analytics_text')}</p>
        </section>

        <section className="space-y-3">
          <h2 className="text-lg font-semibold text-foreground">{t('privacy_ads_title')}</h2>
          <p className="text-foreground/80 leading-relaxed">{t('privacy_ads_text')}</p>
        </section>

        <section className="space-y-3 bg-primary/5 border border-primary/20 rounded-xl p-4">
          <h2 className="text-lg font-semibold text-primary">{t('privacy_no_server_title')}</h2>
          <p className="text-foreground/80 leading-relaxed">{t('privacy_no_server_text')}</p>
        </section>

        <section className="space-y-3">
          <h2 className="text-lg font-semibold text-foreground">{t('privacy_lgpd_title')}</h2>
          <p className="text-foreground/80 leading-relaxed">{t('privacy_lgpd_text')}</p>
          <ul className="list-disc list-inside text-foreground/80 space-y-1 ml-2">
            <li>{t('privacy_lgpd_item1')}</li>
            <li>{t('privacy_lgpd_item2')}</li>
            <li>{t('privacy_lgpd_item3')}</li>
            <li>{t('privacy_lgpd_item4')}</li>
            <li>{t('privacy_lgpd_item5')}</li>
          </ul>
        </section>

        <section className="space-y-3">
          <h2 className="text-lg font-semibold text-foreground">{t('privacy_rights_title')}</h2>
          <p className="text-foreground/80 leading-relaxed">{t('privacy_rights_text')}</p>
        </section>

        <section className="space-y-3">
          <h2 className="text-lg font-semibold text-foreground">{t('privacy_contact_title')}</h2>
          <p className="text-foreground/80 leading-relaxed">{t('privacy_contact_text')}</p>
        </section>
      </div>
    </div>
  );
}
